import { createAction } from '@reduxjs/toolkit'
import { ModalType } from '../../types/index'

export const setModalNotification = createAction<ModalType>('modal/setModalNotification')
